

import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { getFileSizeInMB } from "@/modules/File/file-size";
import { fileImgUrlByMime } from "@/modules/File/file-icons";
import IBSpinner from "@/components/IBLoading/IBSpinner.vue";
import { FileListItem, FileMimeByExt } from "@/components/IBFile/interface";
import IBFileListItemAppendItem from "@/components/IBFile/IBFileListItemAppendItem.vue";

@Component({
	components: {
		IBSpinner,
		IBFileListItemAppendItem,
	}
})
export default class IBFileListItem extends Vue {

	@Prop(Boolean)
	readonly multiple!: boolean

	@Prop(Boolean)
	readonly error!: boolean

	@Prop(Boolean)
	readonly fill!: boolean

	@Prop({ type: String, default: '/img/icons/chevron-right--silver_dark.svg' })
	readonly appendImgUrl!: string

	@Prop({ type: Array, default: () => [] })
	readonly files!: FileListItem[]

	get fileNames(): string {
		return this.files
			.map(fileItem => fileItem?.file?.name || '')
			.join(', ');
	}

	get subheader(): string {
		if (this.error) return 'Ошибка загрузки';

		return this.multiple ? this.fileNames : this.fileSizeString;
	}

	get title(): string {
		return this.multiple
			? 'Вложения'
			: this.fileNames;
	}

	get fileMime(): string {
		return this.files[0]?.file?.type || '';
	}

	get fileSizeString(): string {
		return getFileSizeInMB(this.files[0]?.file) + ' МБ';
	}

	get prependImgUrl(): string {
		if (this.error) return '/img/icons/error-status.svg';

		return this.multiple
			? '/img/icons/page-check.svg'
			: fileImgUrlByMime[this.fileMime as FileMimeByExt];
	}

	get loadingPercent(): number {
		return this.files.reduce((percent, fileItem?: FileListItem) =>
			percent + Math.min(fileItem?.loadingPercent || 0, 100), 0);
	}

	get averageLoadingPercent(): number {
		return this.loadingPercent / this.files.length;
	}

	get loading(): boolean {
		return !!(this.averageLoadingPercent && this.averageLoadingPercent < 100);
	}

	@Emit('click:append')
	emitClickAppend(): FileListItem[] {
		return this.files;
	}

	@Emit('repeat')
	emitRepeat(): FileListItem[] {
		return this.files;
	}

}

